import { render } from "./QuizAuthPrompt.vue?vue&type=template&id=782da56a"
import script from "./QuizAuthPrompt.vue?vue&type=script&lang=js"
export * from "./QuizAuthPrompt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__